import React, { useState, useCallback } from 'react';

import {useDropzone} from 'react-dropzone'
import TextareaAutosize from 'react-textarea-autosize';
import { useTable } from 'react-table';

import { Button } from '../dumb_component/'
import { trimEnd } from 'lodash';

function filter(a) {
  a = a.filter(e => e != 'undefined');
  a = a.filter(e => e != undefined);
  a = a.filter(e => e != null);
  return a
}

function handleDrop(e) {
  e.stopPropagation(); e.preventDefault();
  return new Promise((resolve, rejet) => {
    var files = e.dataTransfer.files, f = files[0];
    if(files[0].type == 'image/png'){
      e.target.firstChild.src = files[0];
    }
    var reader = new FileReader();
    reader.onload = function(e) {
      var data = new Uint8Array(e.target.result);
      var workbook = XLSX.read(data, {type: 'binary', cellDates: true, dateNF: 'dd/mm/yyyy'});
      var sheetNames = [];
      var sheets = [];
      for(var i = 0; i < workbook.Props.Worksheets; i++) {
        sheetNames.push(workbook.SheetNames[i]);
        sheets.push(XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[i]], { header: 1, blankrows: false }))
      }
      resolve( {
        workbook
      });
    };
    reader.readAsArrayBuffer(f);
  });
}

export const Img = ({id, src, isAdmin, imgHasChanged }) => {
  console.log('img admin, ', isAdmin);
  if(typeof src === 'object')
    src = undefined;
  const [image, setImage] = useState(!!src ? {id: id, src: src} : {});
  if(isAdmin || typeof(src) == 'string') {
    const onDrop = useCallback(acceptedFiles => {
      // Loop through accepted files
      acceptedFiles.map((file, i) => {
        // Initialize FileReader browser API
        const reader = new FileReader();
        // onload callback gets called after the reader reads the file data
        reader.onload = function(e) {
          // add the image into the state. Since FileReader reading process is asynchronous, its better to get the latest snapshot state (i.e., prevState) and update it. 
          setImage({ id: i, src: e.target.result });
        };
        // Read the file as Data URL (since we accept only images)
        reader.readAsDataURL(file);
        return file;
      });
    }, []);

    const accept = 'image/*';
    const {getRootProps, getInputProps } = useDropzone({onDrop, accept})

    function deleteImage() {
      setImage({id: id, src : undefined});
      //imgHasChanged();
    }

    return (
      <div {...getRootProps({
        onClick: event => {
          if(!isAdmin)
            event.stopPropagation();
        },
        style: { minWidth: 80, background: !!image.src ? '#eee' : '#ccc', margin: 10, alignItems: 'flex-start', justifyContent: 'center', padding: 8, outline: 'none'}
      })}>
        {
          !!image.src && isAdmin
            ? <div className='imgMask' { ...getRootProps()} >
                <button
                  className='delete-img-button'
                  onClick= {(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    deleteImage();
                  }}>
                  Supprimer
                </button>
              </div>
            : null
        }     
        <input {...getInputProps()} />
        {
          !!image.src
            ? <img id={id} className='wpc-img img-contained' src={image.src} />
            : <p>Cliquez ou glissez une image ici </p>
        }

      </div>
    )
  }
  return null;
}

/*

export class Img extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: undefined,
      src: undefined
    }
  }

  render() {

    const {id, src, isAdmin} = this.props;

    if(isAdmin || typeof(src) == 'string') {
      const onDrop = useCallback(acceptedFiles => {
        // Loop through accepted files
        acceptedFiles.map((file, i) => {
          // Initialize FileReader browser API
          const reader = new FileReader();
          // onload callback gets called after the reader reads the file data
          reader.onload = function(e) {
            // add the image into the state. Since FileReader reading process is asynchronous, its better to get the latest snapshot state (i.e., prevState) and update it. 
            this.setState({ id: i, src: e.target.result });
          };
          // Read the file as Data URL (since we accept only images)
          reader.readAsDataURL(file);
          return file;
        });
      }, []);
  
      const accept = 'image/*';
      const {getRootProps, getInputProps, rootRef, isDragActive} = useDropzone({onDrop, accept})
  
    }
    if(typeof src === 'object') {
      src = undefined;
    }
    src=undefined;
    return (
      <div {...getRootProps({
        style: { minWidth: 80, background: !!src ? '#eee' : !!this.props.src ? '#eee' : '#ccc', margin: 10, alignItems: 'flex-start', justifyContent: 'center', padding: 8, outline: 'none'}
      })}>
        
        <input {...getInputProps()} />
        {
          !!src
            ? <img id={id} className='wpc-img img-contained' src={src} />
            : !!this.props.src
              ? <img id={id} className='wpc-img img-contained' src={this.props.src} />
              : <p>Cliquez ou glissez une image ici </p>
        }
        {
          !!src || !!this.props.src
            ? <div className='imgMask' { ...getRootProps()} >
                <button
                  className='delete-img-button'
                  onClick= {(e) => {
                    console.log(image);
                    e.preventDefault();
                    e.stopPropagation();
                    this.setState({id: undefined, src: undefined})
                  }}>
                  Supprimer
                </button>
              </div>
            : null
        }
      </div>
    )
  }
}

*/

// <div style={{ minWidth: 80, minHeight: 80, background: '#ccc', margin: 10}} >
export const Title = ({ title }) => {
  return !!title
  ? <span style={{ fontSize: 40, marginBottom: 5}} >{title}</span>
  : null
};

export const Subtitle = ({ subtitle }) => {
  return !!subtitle
  ? <span style={{ marginLeft: 5, fontSize: 32}} >{subtitle}</span>
  : null
};

export const Subsubtitle = ({ text }) => {
  return !!text
  ? <span style={{ fontSize: 27, marginBottom: 5}} >{text}</span>
  : null
};

export const GreyTitle = ({ text }) => {
  return !!text
  ? <span style={{ marginLeft: 10, fontSize: 20, marginBottom: 5, color: 'grey'}} >{text}</span>
  :null
};

export const Text = ({text}) => {
  return !!text
  ? <span style={{ marginLeft: 35, marginBottom: 10, color: 'grey'}} >{text}</span>
  : null
};

export const BasicText = ({ desc, id, src, isAdmin, handleChange, multiline = false, maj = false, display = 'flex', placeHolder = 'Non défini', centered = false }) => {
  if(typeof(src) === 'object')
    src = '';
  const [_text, setText] = useState(src);

  /*function setSelectionRange(input, selectionStart, selectionEnd) {
    if (input.setSelectionRange) {
      input.focus();
      input.setSelectionRange(selectionStart, selectionEnd);
    }
    else if (input.createTextRange) {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveEnd('character', selectionEnd);
      range.moveStart('character', selectionStart);
      range.select();
    }
  }
  
  function setCaretToPos (input, pos) {
    setSelectionRange(input, pos, pos);
  }*/
// console.log('src: ', src);
  if(!!isAdmin || src != undefined)
    return(
      <div className='wpc-text' id={id} style={{ display: display, padding: 2, margin: 3, borderRadius: 5, color: 'grey' }}
        
        onClick={(e)=> {
          let tag = e.target.tagName;
          if(!!isAdmin && tag == 'DIV') {
            if(!!e.target.lastChild.lastChild)
              e.target.lastChild.lastChild.focus();
            else
            e.target.lastChild.focus();
          }
        }}

        onMouseEnter={(e) => {
          let d = document.getElementById(id);
          d.className = `wpc-text ${isAdmin ? 'shadow' : ''}`
        }}

        onMouseLeave={() => {
          let d = document.getElementById(id);
          d.className = 'wpc-text'
        }}>
        <span style={{ whiteSpace: 'nowrap'}} className='no-pointer-events'>{!!desc ? `${desc}:` : ''}</span>
        {
          multiline
          ? <div style={{ width: '100%', height: 'auto'}}>
              <TextareaAutosize className='island-page-textarea' type='text' placeholder={placeHolder} value={_text}
                readOnly={!isAdmin}
                onChange={(tx) => {
                  let str = JSON.stringify(tx.target.value) === JSON.stringify("") ? "" : tx.target.value;
                  let arr = id.split(':::');
                  handleChange(arr[0], arr[1], str);
                  setText(str);
                } }
                style={{color: src == _text ? 'black' : 'red'}}/>
            </div>
          : <div className='overflow' style={{ height: 'auto'}}>
              <input className='island-page-input' type='text' placeholder={placeHolder} value={_text} readOnly={!isAdmin}
                onChange={(tx) => {
                  let str = JSON.stringify(tx.target.value) === JSON.stringify("") ? "" : tx.target.value;
                  let arr = id.split(':::');
                  handleChange(arr[0], arr[1], str);
                  setText(str)
                } }
                style={{ width: '100%', color: src == _text ? 'black' : 'red', textAlign: centered ? 'center' : 'left'}}/>
            </div>
        }
      </div>
    );
  return null;
};

export const HoriBlock = ({flex = 1, src = [''], children, show = true}) => {
  //console.log('HoriBlock children',children)
  if(show)
    return (
      <div style={{ flex: flex, maxHeight: 'none', flexWrap: 'wrap' }} className=''>
        {children}
      </div>
    );
  return null
};

export const VertiBlock = ({flex = 1, children, title, subtitle, show = true, padding = 10}) => {
  if(show)
    return (
      <div style={{ display: 'flex', flex: flex, background: 'white', borderRadius: 5, padding: padding, margin: 5, maxHeight: 'none' }} className='flex-dir-column'>
        <Title title={title} />
        <div className='flex-dir-column' style={{ padding: 5}}>
          <Subtitle subtitle={subtitle} />
          <div className='flex-dir-column' style={{ padding: 5 }}>
            {children}
          </div>
        </div>
      </div>
    );
  return null
};

function fixDate(date) {
    console.log("date: ", date);
    let d = new Date(date);
    const month = d.getMonth() + 1;
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    console.log("new date :", `${day}/${month}/${year}`)
    return `${day}/${month}/${year}`;
}

export const VertiTableBlock = ({flex = 1, title, id, data, src, isAdmin, handleChange, setShow }) => {
  console.log({data, src, isAdmin})

  let display = 'none';
  let maxLength = 0;
  data.forEach(line => maxLength = line[1].fields.length > maxLength ? line[1].fields.length : maxLength);

  let content = data.map((line, i)=> {
    let [desc, _data] = line;
    
    let blankFiller = [];
    for(let ii =_data.fields.length; ii < maxLength; ii++)
      blankFiller.push(' ');

    let hasData = false;

    _data.fields.forEach(field => {
      if(!hasData)
        hasData = !!src[_data.table] ? !!src[_data.table][field] : false;
    });

    let fixedDate, fixedDateZSC, fixedDateZPS;

    if(!!src[_data.table] && !!src[_data.table].DATE)
      fixedDate = fixDate(src[_data.table].DATE);
    if(!!src[_data.table] && !!src[_data.table].DATE_ZSC)
      fixedDateZSC = fixDate(src[_data.table].DATE_ZSC);
    if(!!src[_data.table] && !!src[_data.table].DATE_ZPS)
      fixedDateZPS = fixDate(src[_data.table].DATE_ZPS);

    console.log({fixedDate, fixedDateZSC, fixedDateZPS})

    if(isAdmin || hasData)
      return(
        <div style={{ padding: 4, flexDirection: 'column' }} key={i}>
          {
            !!desc ? 
              <div className='row-table-cell' style={{ whiteSpace: 'noWrap', color: 'grey' }}>
                {`- ${desc}:`}
              </div>
            :
            null
          }
          <div>
            {
              _data.fields.map((field, ii) => {
                return(
                  <div className='row-table-cell' key={ii} >
                    <BasicText id={`${_data.table}:::${field}`} desc='' src={!!src[_data.table] ? field === "DATE" ? fixedDate : field === "DATE_ZSC" ? fixedDateZSC : field === "DATE_ZPS" ? fixedDateZPS : src[_data.table][field] : undefined} isAdmin={isAdmin}
                      handleChange={ (text) => handleChange(_data.table, field, text)} setShow={() => setShow()}/>
                  </div>
                )
              })
            }
            {
              blankFiller.map((b, ii) => <div key={ii} className='row-table-cell'></div>)
            }
          </div>
          
        </div>
      )
    return null
  });

  content = filter(content)

  if(!!content.length)
    display = 'flex'

    return (
      <div className='flex-dir-column'>
        <div style={{ display: display, flex: flex, justifyContent: 'center', background: 'white', borderRadius: 5}}
        className='row-table'>
          {content}
        </div>
      </div>
    );
};

export const HoriTableBlock = ({flex = 1, src, data, isAdmin, handleChange}) => {

  let display = 'none';
  let overHeader = {};
  let header = [];
  let tableData = [];
  let tableFieldsRelation = [];
  let highestIndexOfData = 0;

  // helper to lay out the entire table if at least one value is known
  let hasContent = false;
  function check(array) {
    return array.forEach(d => {
      if(Array.isArray(d[1]))
        return check(d[1])
      else {
        d[1].fields.forEach(f => {
          if(!!src[d[1].table] && !!src[d[1].table][f])
            hasContent = true
        })
      }
    })
  }
  check(data);
  // end

  data.forEach((line, i) => {

    if(Array.isArray(line[1])) {
      let [desc, _data] = line;
      let colSpan = 0;

      // deal with headers
      _data.forEach(innerLine => {
        if(isAdmin || innerLine[1].fields.some(e => {
          if(!!src[innerLine[1].table])
            Object.values(src[innerLine[1].table]).includes(e)
          else return false
        })) {
          header.push(innerLine[0]);
          tableFieldsRelation.push(innerLine[1].table)
        }
        if(isAdmin || src[innerLine[1].table] && src[innerLine[1].table][innerLine[1].fields] != undefined)
          colSpan++;
      });
      if(!!colSpan)
        overHeader[i]= [desc, colSpan];

      // deal with table data
      _data.forEach(innerLine => {
        let columnsFields = [];
        innerLine[1].fields.forEach(field => {
          if(isAdmin || src[innerLine[1].table] &&  src[innerLine[1].table][field] != undefined) {
            columnsFields.push(field);
          }
        });
        tableData.push(columnsFields);
      });
    } else {
      let [desc, obj] = line;

      if(isAdmin || hasContent || !!src[obj.table] && obj.fields.some(e => Object.keys(src[obj.table]).includes(e)) ) {
        header.push(desc);
        tableFieldsRelation.push(line[1].table)
        let columnsFields = [];
        obj.fields.forEach(field => {
          if(isAdmin || !!src[obj.table] && src[obj.table][field] != undefined) {
            columnsFields.push(field);
          }
        });
        tableData.push(columnsFields);
      };
    };

   tableData.forEach(line => {
      if(line.length > highestIndexOfData)
        highestIndexOfData = line.length - 1;
    });
  });

  if(!!tableData.length)
    display = 'flex';

  let overTitleLastIndex = 0;
  if(isAdmin || !!tableData.length)
    return (
      <div style={{ display: display, flex: 0, justifyContent: 'center', background: 'white', borderRadius: 5, padding: 10, margin: 5}} className='flex-dir-column'>
        <div className='column-table' style={{ alignSelf: 'center', justifySelf: 'center', justifyContent: 'center'}}>
          <div style={{ padding: 2 }}>
            {header.map((v, i) => {
              if(!!overHeader[i])
                return <div style={{justifyContent: 'center', paddingBottom: 3, color: 'grey', borderBottom: '2px dotted #ccc', borderRight: i == overTitleLastIndex ? 'none' : '2px dotted #ccc', flex: overHeader[i][1]}} key={i}>{overHeader[i][0]}</div>
              else if(i + 1 == header.length)
                return null
              else
                return <div key={i}></div>
            })}
          </div>
          <div>
            {header.map((v, i) => {
              if(typeof(v) == 'object'){
                v.shift();
                return v.map((vv, ii) => {
                  return <div className='column-table-cell' style={{ justifyContent: 'center', color: 'grey', borderRight: i + 1 == header.length ? 'none' : '1px solid #ccc'}} key={ii}>{vv}</div>
                })
              } else
                return <div className='column-table-cell' style={{ justifyContent: 'center', color: 'grey', borderRight: i + 1 == header.length ? 'none' : '1px solid #ccc'}} key={i}>{v}</div>
            })}
          </div>
          <div>
            {tableData.map((fields, fieldIndex) => {
              return (
                <div className='column-table-cell' key={fieldIndex} style={{ borderRight: fieldIndex + 1 == tableData.length ? 'none' : '1px solid #ccc' }}>
                  <ul style={{ margin: 0}}>
                    { 
                      fields.map((field, ii) => {
                        return (<li key={ii}>
                          <BasicText key={ii} id={`${tableFieldsRelation[fieldIndex]}:::${field}`} desc='' src={src[tableFieldsRelation[fieldIndex]] ? src[tableFieldsRelation[fieldIndex]][field] : undefined} isAdmin={isAdmin}
                            handleChange={ (text) => handleChange(tableFieldsRelation[fieldIndex], field, text)} />
                        </li>)
                      })
                    }
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  return null
}


export const CensusList = ({isAdmin, title, censusData, displayLR = true, decennal = false, census, handleChange, show}) => {


  if(!!censusData && !!Object.keys(censusData).length || isAdmin) {

    let displayedYears = [];
    // if not decennal, retrive the last five years
    if(!decennal) {
      let year = new Date().getFullYear();
      for(let i = 0; i <= 4; i++) {
        displayedYears.push(year - 4 + i);
      }
    }
    else {
      displayedYears = [ '68 - 70', '76 - 79', '87 - 89', '97 - 00', '09 - 12', '20 - 23'];
    }

    let decennalYears = [ [1968, 1970], [1976, 1979], [1987, 1989], [1997, 2000], [2009, 2012], [2020, 2023]];


    let header = [
      { Header: "Statut Monde", accessor: "STATUT_MONDE"},
      { Header: "Statut EU", accessor: "STATUT_EU"},
      { Header: "Statut FR", accessor: "STATUT_FR"},
      { Header: "Statut BZH", accessor: "STATUT_BZH"},
    ];

    header.unshift({ Header: "Nom vernaculaire", accessor: "NOM_VERN"});
    header.unshift({ Header: "Nom scientifique", accessor: "NOM_SCI"});

    let trimmedData = {};

    if(!!censusData) {
      censusData.forEach(entry => {
        if(!trimmedData[entry.NOM_VERN]) {
          trimmedData[entry.NOM_VERN] = entry;
        }
      })
    }

    let tableData = [];

    if(!!trimmedData){
      let noms_vern = Object.keys(trimmedData);

      if(decennal) {
        noms_vern.forEach(nom_vern => {
          let tmp = {};
          Object.keys(trimmedData[nom_vern]).forEach(year => {
            decennalYears.forEach((years, index) => {
              for(var i = years[0]; i < years[1]; i++) {
                if(i == year) {
                  tmp.nom_vern = nom_vern;
                  let key = displayedYears[index].replace("-", "_");
                  key = key.replace(/\s/g, "");
                  tmp[key] = trimmedData[nom_vern][year].R_D_MOY;
                }
              }
            })
          });

          if(!!Object.keys(tmp).length){
            tableData.push(tmp);
          }
        });
      }
      else { 
        let targetKey = census == 'OISEAUX_MARINS_NICHEURS'
            ? 'NOM_VERN'
            : census == 'AUTRES_SP_AVIF'
              ? 'RESULT'
              : census == 'WETLAND'
                ? 'EFF_WETLAND_MIN'
                : undefined

        console.log('Target Key :', targetKey);

        noms_vern.forEach(nom_vern => {
          tableData.push(nom_vern);
        });
      }
    }
    tableData = Object.values(trimmedData);
    console.log('TABLE DATA : ', tableData);

    const data = React.useMemo(
      () => tableData,
      []
    )

    const columns = React.useMemo(
      () => header,
      []
    )
 
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
    } = useTable({ columns, data });
 
    if(!!tableData.length){
      return (
        <div style={{ flexDirection: 'column', alignItems: 'center'}}>
          <p style={{color: 'grey', marginBottom: 10}}>{title}</p>
          <table {...getTableProps()} style={{ border: 'solid 1px lightgrey', borderSpacing: 0 }}>
              
              <thead>

                {headerGroups.map(headerGroup => (

                  <tr {...headerGroup.getHeaderGroupProps()}>

                    {headerGroup.headers.map((column, i) => (

                      <th

                        {...column.getHeaderProps()}

                        style={{

                          border: 'solid 1px lightgrey',

                          color: 'black',

                          fontWeight: 'bold',

                          padding: 10

                        }}

                      >

                        {column.render('Header')}
                        <br />
                        {census === "WETLAND" && i != 0 ? "min - max" : null}

                      </th>

                    ))}

                  </tr>

                ))}

              </thead>

              <tbody {...getTableBodyProps()}>

                {rows.map(row => {

                  prepareRow(row)

                  return (

                    <tr {...row.getRowProps()}>

                      {row.cells.map(cell => {
                        let color;
                        switch(cell.value) {
                          case "CR" :
                            color = "#D3050C";
                            break;
                          case "EN" :
                            color = "#FCBD00";
                            break;
                          case "VU" :
                            color = "#FFED00";
                            break;

                          case "NT" :
                            color = "#FBF2CB";
                            break;
                          case "LC" :
                            color = "#74B94C";
                            break;
                          case "NA" :
                            color = "#919291";
                            break;
                          default:
                            color = "white"

                        }
                        return (

                          <td

                            {...cell.getCellProps()}

                            style={{

                              padding: '10px',

                              border: 'solid 1px lightgrey',

                              textAlign: 'center',

                              background: color

                            }}

                          >

                            {cell.render('Cell')}

                          </td>

                        )

                      })}

                    </tr>

                  )

                })}

              </tbody>

              </table>
            </div>
      )
    }
/*
    let tmp = !!data ? !!Object.keys(trimmedData).length ? true : false : false;

    let content = tmp
      ? Object.keys(trimmedData).map((key, i) => {
        let keyContent = decennal 
          ? decennalYears.map((years, i) => {
              let yearSegmentHasValue = false;
              
              for(var year = years[0]; year <= years[1]; year++) {
                let value = !!data[key]
                  ? !!data[key][year]
                    ? data[key][year]['R_D_MOY'] != undefined
                      ? data[key][year]['R_D_MOY']
                      : undefined
                    : undefined
                  : undefined

                if(!!value) {
                  yearSegmentHasValue = true;
                  
                  return(
                    <div style={{borderLeft: '1px solid #ccc', justifyContent: 'center'}} key={year}>
                      <BasicText key={i} id={`decennal:${census}::${key}:::${year}`} desc='' centered
                        src={
                          !!data[key]
                          ? !!data[key][year]
                            ? data[key][year]['R_D_MOY'] != undefined
                              ? data[key][year]['R_D_MOY']
                              : undefined
                            : undefined
                          : undefined
                        }
                        isAdmin
                        handleChange={ (text) => handleChange()} placeHolder=' '/>
                    </div>
                  )
                }
              }
              if(!yearSegmentHasValue)
                return (
                  <div style={{borderLeft: '1px solid #ccc', justifyContent: 'center'}} key={year}>
                    <BasicText key={i} id={`decennal:${census}::${key}:::${years[0]}`} desc='' centered
                      src={ undefined }
                      isAdmin
                      handleChange={ (text) => handleChange()} placeHolder=' '/>
                    </div>
                )
            }
          )
        : displayedYears.map((year, i) => {
          let targetKey = census == 'OISEAUX_MARINS_NICHEURS'
            ? 'RESULT_SUIVIS'
            : census == 'AUTRES_SP_AVIF'
              ? 'RESULT'
              : census == 'WETLAND'
                ? 'EFF_WETLAND'
                : undefined
            return(
              <div style={{borderLeft: '1px solid #ccc', justifyContent: 'center'}} key={year}>
                <BasicText key={i} id={`${census}::${key}:::${year}`} desc='' centered
                  src={
                    !!data[key]
                    ? !!data[key][year]
                      ? data[key][year][targetKey] != undefined
                        ? data[key][year][targetKey]
                        : undefined
                      : undefined
                    : undefined
                  }
                  isAdmin
                  handleChange={ (text) => handleChange()} placeHolder=' '/>
              </div>
            ) 
        })

        return(
          <div key={i}>
            <div style={{ color: 'grey'}}>{key}</div>
            {
              displayLR
              ? <BasicText key={'fr' + i} id={`${census}::${key}:::STATUT_FR`} desc='' centered
                  src={ 
                    !!data[key]
                    ? data[key].STATUT_FR != undefined
                      ? data[key].STATUT_FR
                      : undefined
                    : undefined
                   }
                  isAdmin
                  handleChange={ (text) => handleChange()} placeHolder=' '/>
              : <div style={{ flex: 0}}/>
            }
            {
              displayLR
              ? <BasicText key={'bzh' + i} id={`${census}::${key}:::STATUT_BZH`} desc='' centered
                  src={ 
                    !!data[key]
                    ? data[key].STATUT_BZH != undefined
                      ? data[key].STATUT_BZH
                      : undefined
                    : undefined
                   }
                  isAdmin
                  handleChange={ (text) => handleChange()} placeHolder=' '/>
              : <div style={{ flex: 0}}/>
            }
            {keyContent}
          </div>
        )
      })
    : undefined

    return(
      <div className='flex-dir-column' style={{ maxWidth: '90%', margin: 'auto', paddingTop: 30}}>
        <div style={{ alignSelf: 'center', margin: 10}}>{title}</div>
        {
          !!content
          ? <div className='flex-dir-column'>
              <div>
                {header}
              </div>
              {content}
            </div>
          : <span style={{color: 'grey', alignSelf: 'center'}}>Pas de données</span>
        }
      </div>
    )*/
  }
  return null
}